export const truncateText = (
  value: string | undefined | null,
  maxLength: number,
  addEllipsis = true
): string => {
  if (!value) return '';

  const trimmed = value.trim();

  if (trimmed.length <= maxLength) {
    return trimmed;
  }

  const truncated = trimmed.slice(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(' ');

  const finalText =
    lastSpaceIndex === -1 ? truncated : truncated.slice(0, lastSpaceIndex);

  return addEllipsis ? finalText + '...' : finalText;
};

export const normalizeText = (value: string | undefined | null): string => {
  if (!value) return '';

  return value
    .replace(/\r?\n|\r/g, ' ') // remove line breaks
    .replace(/\s+/g, ' ') // collapse multiple whitespace into one space
    .trim(); // remove leading/trailing spaces
};
